import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <p className="footer-text">
            © {currentYear} BBB Blog.A rising star of rythem game
          </p>
          <ul className="footer-links">
            <li>
              <a 
                href="https://github.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-link"
              >
                GitHub
              </a>
            </li>
            <li>
              <a href="/about" className="footer-link">
                关于我们
              </a>
            </li>
            <li>
              <a href="/archive" className="footer-link">
                文章归档
              </a>
            </li>
            <li>
              <a href="mailto:contact@example.com" className="footer-link">
                联系我们
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;